import { RouteObject } from "react-router-dom";
import OrderReceiptPage from "../pages/Orders/OrderReceiptPage";
import OrdersPage from "../pages/Orders/OrdersPage";

export const ordersRoutes: RouteObject[] = [
    { path: "/orders/:orderId", element: <OrdersPage /> },
    { path: "/orders/:orderId/receipt", element: <OrderReceiptPage /> },
];
